<template>
  <div :style="{ 'width': clientWidth + 'px', 'height': clientHeight + 'px' }" class="ForgetPassword">
    <div class="layer">
      <div class="content">
        <div class="Tit">忘记密码</div>
        <div class="int">
          <el-input type="text" class="phone" v-model="mobile" placeholder="请输入手机号" @input="handleClick"/>
        </div>
        <div class="int">
          <el-input type="text" @keyup.enter.native="getCode" class="code" v-model="code" placeholder="请输入验证码"/>
          <span @click="getCode">{{count}}</span>
        </div>
        <div class="int password">
          <el-input type="password" class="password" v-model="password" placeholder="请输入密码"/>
        </div>
        <div class="int password">
          <el-input type="password" @keyup.enter.native="forgetPassword" class="password" v-model="repassword"
                    placeholder="请输入再次密码"/>
        </div>
        <div @click="forgetPassword" class="click">提交</div>
        <div class="Txt">
          <router-link tag="span" replace to="/login">返回登录</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        clientWidth: '',
        clientHeight: '',
        mobile: '',
        password: '',
        code: '',
        repassword: '',
        count: '获取验证码', // 按钮里显示的内容
        totalTime: 60, // 记录具体倒计时时间
        canClick: true // 添加canClick
      }
    },
    mounted () {
      this.clientWidth = document.documentElement.clientWidth
      this.clientHeight = document.documentElement.clientHeight
      window.onresize = function () {
        this.clientWidth = document.documentElement.clientWidth
        this.clientHeight = document.documentElement.clientHeight
      }
    },
    created () {

    },
    methods: {
      forgetPassword () {
        if (this.mobile === '') {
          this.$message({
            duration: 2000,
            type: 'error',
            message: '请输入手机号码'
          })
          return false
        }
        if (this.code === '') {
          if (this.mobile === '') {
            this.$message({
              duration: 2000,
              type: 'error',
              message: '请输入验证码'
            })
          }
          return false
        }
        if (this.password === '') {
          this.$message({
            duration: 2000,
            type: 'error',
            message: '请输入密码'
          })
          return false
        }
        if (this.repassword === '') {
          this.$message({
            duration: 2000,
            type: 'error',
            message: '请再次输入密码'
          })
          return false
        }
        this.$http.post('/apipx/User/forgetpwd', {
          mobile: this.mobile,
          code: this.code,
          password: this.password,
          repassword: this.repassword
        }).then(res => {
          if (res.code === 0) {
            this.$message({
              message: res.msg,
              type: 'success',
              duration: 2000
            })
            this.$router.replace('/login')
          }
        })
      },
      handleClick () { // 验证数字
        console.log(this.phone)
        this.mobile = this.phone.replace(/[^\w]/g, '')
      },
      getCode () { // 获取验证码
        let reg = 11 && /^((13|14|15|17|18|19)[0-9]{1}\d{8})$/
        if (this.mobile === '') {
          this.$message({
            duration: 2000,
            type: 'error',
            message: '请输入手机号码'
          })
          return false
        }
        if (!reg.test(this.mobile)) {
          if (this.mobile === '') {
            this.$message({
              duration: 2000,
              type: 'error',
              message: '请输入正确手机号码'
            })
          }
          return false
        }
        if (!this.canClick) {
          return false
        }
        this.$http.post('/apipx/Tool/send', {
          mobile: this.mobile
        }).then(res => {
          if (res.code === 0) {
            this.$message({
              message: res.msg,
              type: 'success',
              duration: 2000
            })
          }
        })

        this.canClick = false
        this.count = this.totalTime + 's'
        var clock = setInterval(() => {
          this.totalTime--
          this.count = this.totalTime + 's'
          if (this.totalTime < 0) {
            clearInterval(clock)
            this.count = '获取验证码'
            this.totalTime = 60
            this.canClick = true // 这里重新开启
          }
        }, 1000)
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .ForgetPassword {
    background: url("bg.png") no-repeat center center;

    .layer {
      width: 993px;
      height: 500px;
      position: fixed;
      background: url("layer.png") no-repeat center center;
      left: 50%;
      top: 50%;
      margin: -250px 0px 0px -496.5px;

      .content {
        width: 300px;
        overflow: hidden;
        margin-left: 530px;

        .Tit {
          width: 300px;
          font-size: 20px;
          text-align: center;
          font-weight: bold;
          margin: 55px auto 40px;
        }

        .int {
          width: 300px;
          height: 44px;
          margin: 10px auto 0;
          position: relative;

          .phone {
            input {
              background: url("phone.png") no-repeat 3% 50%;
              background-size: 35px 35px;
            }
          }

          .password {
            input {
              background: url("password.png") no-repeat 3% 50%;
              background-size: 35px 35px;
            }
          }

          .code {
            input {
              background: url("code.png") no-repeat 3% 50%;
              background-size: 35px 35px;
            }
          }

          input {
            width: 298px;
            height: 42px;
            border: 1px solid #c6c6c6;
            color: #c6c6c6;
            line-height: 42px;
            padding: 0;
            text-indent: 40px;
          }

          span {
            color: #fc8375;
            position: absolute;
            top: 0;
            right: 10px;
            cursor: pointer;
            line-height: 44px;
          }
        }

        .click {
          width: 300px;
          height: 45px;
          background-color: #ff8484;
          text-align: center;
          line-height: 45px;
          color: #fff;
          border-radius: 10px;
          cursor: pointer;
          margin: 36px auto 0;

          &:hover {
            background-color: #fc9797;
          }

          &:active {
            width: 298px;
            height: 43px;
            border: 1px solid #ff8484;
          }
        }

        .Txt {
          width: 300px;
          text-align: right;
          color: #ff8484;
          margin: 10px auto 0;
          cursor: pointer;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ForgetPassword/ForgetPassword.vue